/* eslint-disable */
import React, {useState} from 'react';
import {useDropzone} from 'react-dropzone';
import XLSX from 'xlsx';
import './styles.scss';
import ConfirmationModal from './confirmationModal';

export const UploadFile = () => {
  const [showConfirmation, setShowConfirmation] = useState(false);
  const [sheetsList, setSheetsList] = useState([]);
  const [acceptedFile, setAcceptedFile] = useState({});

  const onDrop = (acceptedFile) => {
    const reader = new FileReader();
    reader.onload = (evt) => {
      const bstr = evt.target.result;
      const wb = XLSX.read(bstr, {'type': 'binary'});
      setSheetsList(wb.SheetNames || []);
      setAcceptedFile(acceptedFile);
      setShowConfirmation(true);
    };
    reader.readAsBinaryString(acceptedFile[0]);
  };

  const {fileRejections, getRootProps, getInputProps} = useDropzone({
    onDrop,
    'accept': {
      'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet': [],
      'application/vnd.ms-excel': [],
    },
    'multiple': false,
  });
  return (
    <>
      <section className="vehicle-price__upload-segment">
        <div {...getRootProps({'className': 'vehicle-price__dropzone-container'})}>
          <input {...getInputProps()} />
          <svg
            xmlns="http://www.w3.org/2000/svg"
            width="50"
            height="50"
            fill="currentColor"
            className="bi bi-upload"
            viewBox="0 0 16 16"
          >
            <path d="M.5 9.9a.5.5 0 0 1 .5.5v2.5a1 1 0 0 0 1 1h12a1 1 0 0 0 1-1v-2.5a.5.5 0 0 1 1 0v2.5a2 2 0 0 1-2 2H2a2 2 0 0 1-2-2v-2.5a.5.5 0 0 1 .5-.5z" />
            <path d="M7.646 1.146a.5.5 0 0 1 .708 0l3 3a.5.5 0 0 1-.708.708L8.5 2.707V11.5a.5.5 0 0 1-1 0V2.707L5.354 4.854a.5.5 0 1 1-.708-.708l3-3z" />
          </svg>
          <p className='mt-2'>
            Arrastre aquí el archivo o súbalo{' '}
            <em>haciendo click sobre este texto.</em>{' '}
          </p>
          {fileRejections.length > 0 && (
            <em className="warning-message">
              Archivo no aceptado, verifique que sea un archivo de Excel.
            </em>
          )}
        </div>
      </section>
      <ConfirmationModal
        showConfirmation={showConfirmation}
        setShowConfirmation={setShowConfirmation}
        options={sheetsList}
        acceptedFile={acceptedFile}
      />
    </>
  );
};
